import { Injectable, NgZone, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor, registerPlugin } from '@capacitor/core';
import { STORY_PLAYER } from '@storees/shared-constants';
import { normalizeShareCreatedAtParam } from '../utils/public-story-assets';

interface InstallReferrerResult {
  referrer: string;
  alreadyRead?: boolean;
  error?: string;
}

interface InstallReferrerPlugin {
  getReferrer(): Promise<InstallReferrerResult>;
}

const InstallReferrer = registerPlugin<InstallReferrerPlugin>('InstallReferrer');

@Injectable({ providedIn: 'root' })
export class InstallReferrerService {
  private router = inject(Router);
  private ngZone = inject(NgZone);

  /**
   * Read the Play Install Referrer on first launch (Android only).
   * If the referrer contains storyId + createdAt, navigate to story-player.
   * Safe to call on any platform — no-ops on iOS / web.
   */
  async checkAndNavigate(): Promise<void> {
    if (Capacitor.getPlatform() !== 'android') {
      return;
    }

    try {
      const result = await InstallReferrer.getReferrer();
      if (result.alreadyRead || !result.referrer) {
        return;
      }

      const params = new URLSearchParams(result.referrer);
      const storyId = params.get('storyId');
      const createdAtRaw = params.get('createdAt');
      const createdAt = createdAtRaw
        ? normalizeShareCreatedAtParam(createdAtRaw)
        : null;

      if (storyId && createdAt) {
        console.log('Install referrer contains story params — navigating', { storyId, createdAt });
        this.ngZone.run(() => {
          void this.router.navigate([`/${STORY_PLAYER}`], {
            queryParams: { storyId, createdAt },
            replaceUrl: true,
          });
        });
      }
    } catch (e) {
      console.warn('Install referrer unavailable', e);
    }
  }
}
